import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

const defaultWaiver = {};

export default {
  actions: {
    async [actions.DO_CREATE_WAIVER]({ commit }, params) {
      const { data } = await HTTP.post('/waivers', params);
      commit(mutations.SET_WAIVER, data.data.waivers[0]);
      return data;
    },
    async [actions.DO_DELETE_WAIVER]({ commit }, payload) {
      const { id, ignore, ...params } = payload;
      const { data } = await HTTP.delete(`/waivers/${id}`, { params });
      if (!ignore) commit(mutations.SET_WAIVER, data.data.waivers[0]);
      return data;
    },
    async [actions.DO_GET_WAIVER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/waivers/${id}`, { params });
      commit(mutations.SET_WAIVER, data.data.waivers[0]);
      return data;
    },
    async [actions.DO_GET_WAIVERS]({ commit }, params) {
      const { data } = await HTTP.get('/waivers', { params });
      commit(mutations.SET_WAIVERS, data.data.waivers);
      return data;
    },
    async [actions.DO_UPDATE_WAIVER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/waivers/${id}`, params);
      commit(mutations.SET_WAIVER, data.data.waivers[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_WAIVER]: state => state.waiver,
    [getters.GET_WAIVERS]: state => state.waivers,
  },
  mutations: {
    [mutations.SET_WAIVER](state, waiver) {
      state.waiver = waiver;
    },
    [mutations.SET_WAIVER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.waiver;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_WAIVERS](state, waivers) {
      state.waivers = waivers;
    },
    [mutations.UNSET_WAIVER](state) {
      state.waiver = _.cloneDeep(defaultWaiver);
    },
  },
  state: {
    waiver: _.cloneDeep(defaultWaiver),
    waivers: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/waiver.js